import React, { PureComponent } from "react";
import { NavLink } from "react-router-dom";
import { Icon } from "@ss/mtd-react3";
// import { Ajax } from '../../utils';
import AboutUs from "@/assets/images/aboutus.jpg";
// import Logo from "@/assets/images/logo.jpg";
import Logo from "@/assets/images/logo-temp.jpg";
import Typography from "@/assets/images/typography.jpg";
import Color from "../../assets/images/color.jpg";
import ArrowRight from "../../assets/images/arrow-right.png";

import "./style.scss";
import { getUserInfo } from "@/utils/index";
// 导航菜单数据

// 品牌资源卡片数据
const brandCards = [
    {
        id: "about",
        title: "About us",
        image: AboutUs
    },
    {
        id: "logo",
        title: "Logo",
        image: Logo
    },
    {
        id: "color",
        title: "Color",
        image: Color
    },
    {
        id: "typography",
        title: "Typography",
        image: Typography
    }
];

const aboutUsPath =
    process.env.REACT_APP_DEPLOY_ENV === "production"
        ? "/assets/brand-guidelines/detail?materialCode=BRAND_MATERIAL_20250516_183009BNk"
        : "/assets/brand-guidelines/detail?materialCode=BRAND_MATERIAL_20250514_183502eBD";

export default class BrandBook extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            // currentIndex: 0,
            // bannarList: []
            hoverId: null
        };
    }

    async componentDidMount() {
        // this.getBrandList();
    }

    handleMoreJump = id => {
        if (id === 1) {
            window.location.href = `${window.location.origin}/assets-internal/gallery/1`;
        }
        if (id === 2) {
            window.location.href = `${window.location.origin}/assets-internal/typeface`;
        }
    };
    handleMoreClick = () => {
        console.log(this.props);

        this.props.history.push({
            pathname: "/brand-guidelines/sections", // 添加参数到 URL
            state: { type: "all" }
        });
    };
    render() {
        // const {
        //   currentIndex, bannarList
        // } = this.state;
        const { hoverId } = this.state;
        return (
            <div className="main">
                <div className="brand-page page-container">
                    <div className="title">Brand Guidelines</div>
                    <div className="subtitle">
                        We help people eat better, live better.
                    </div>

                    {/* 品牌资源卡片区域 */}
                    <div className="card-grid-book">
                        {brandCards.map(card => (
                            <NavLink
                                key={card.id}
                                className="card-book"
                                to={
                                    card.id === "about"
                                        ? {
                                              pathname: `${aboutUsPath}`,
                                              target: "_blank" // 新窗口打开
                                          }
                                        : {
                                              pathname:
                                                  "/brand-guidelines/sections",
                                              state: {
                                                  type: card.title.toLowerCase()
                                              }
                                          }
                                }
                                onClick={e => {
                                    if (card.id === "about") {
                                        e.preventDefault(); // 阻止默认跳转
                                        window.open(`${aboutUsPath}`, "_blank");
                                    }
                                }}
                            >
                                <div className="card-image-book">
                                    <img
                                        src={card.image}
                                        alt={card.title}
                                        onMouseEnter={() =>
                                            this.setState({ hoverId: card.id })
                                        }
                                        onMouseLeave={() =>
                                            this.setState({ hoverId: null })
                                        }
                                    />
                                </div>
                                <div className="card-title">
                                    {card.title}
                                    {hoverId === card.id && (
                                        <Icon
                                            className="icon-big"
                                            type="arrow-right"
                                        />
                                    )}
                                </div>
                            </NavLink>
                        ))}
                    </div>

                    {/* 查看更多按钮 */}
                    <div
                        className="more-section"
                        onClick={this.handleMoreClick}
                    >
                        <div className="more-btn">
                            View more
                            <Icon className="icon-left" type="arrow-right" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
